
export default {
   serverUrl: 'https://api.adsarchitect.co.in/api/',
  // serverUrl: 'http://192.168.29.25:5053/api/', 
};  
